/**
 *  @class
 *  @function ToggleBoxes
 */
if (!customElements.get('toggle-box')) {
  class ToggleBox extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.toggle-box--button');
      this.imageTrigger = this.querySelector('[data-toggle-box-image]');
      this.imageClickToggle = this.dataset.imageClickToggle === 'true';

      this.toggle = this.toggle.bind(this);
      this.syncExpandedState();

      if (this.imageClickToggle) {
        this.addEventListener('click', this.toggle);

        this.imageTrigger?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggle();
          }
        });
      } else {
        this.button.addEventListener('click', this.toggle);
      }
    }

    toggle() {
      this.toggleAttribute('open');
      this.syncExpandedState();
    }

    syncExpandedState() {
      const expanded = this.hasAttribute('open');
      this.button?.setAttribute('aria-expanded', expanded);
      this.imageTrigger?.setAttribute('aria-expanded', expanded);
    }
  }
  customElements.define('toggle-box', ToggleBox);
}
